import { useState } from "react";
import { Button, Col, Modal, Row } from "antd";
import { useConnectPlatforms } from "./hooks/useConnectPlatforms";
import EmailModal from "./EmailModal";
import FeatureComingSoon from "../../../common/FeatureComingSoon";

const Integrations = () => {
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [isRemove, setRemove] = useState(false);
  const { handleConnect, platforms, platformConfiguration, handleDisconnect } =
    useConnectPlatforms();
  const handleCancel = () => {
    setRemove(false);
  };

  return (
    <div className="platform-card">
      <p className="heading24px fw-bold">Connected Platforms</p>
      <p className="text-color-848484 fw-normal mb10">
        Manage your review platform integrations.
      </p>
      {platforms?.map((platform, i) => {
        const isConnected = platformConfiguration?.providerType
          ? platformConfiguration?.providerType === platform?.providerType
          : false;
        return (
          <Row
            key={i}
            gutter={[16, 16]}
            className={`align-items-center connect-card ${platforms?.length - 1 !== i ? "border-b" : ""}`}
          >
            <Col
              xs={24}
              md={21}
              lg={22}
              className="d-flex align-items-center gap-20"
            >
              <img
                src={platform?.logo}
                alt={platform?.name}
                style={{ width: 60, height: 60, objectFit: "contain" }}
              />
              <div>
                <div className="heading18px fw-medium">{platform?.name}</div>
                <p className="text-color-848484 fw-normal">
                  {isConnected ? "" : "Not"} Connected
                </p>
              </div>
            </Col>
            <Col xs={24} md={3} lg={2} className="d-flex justify-content-end">
              <Button
                className="secondary-btn"
                onClick={() => {
                  if (!!platform?.providerType) {
                    if (isConnected) {
                      setRemove(true);
                    } else {
                      setIsModalOpen(platform?.name);
                    }
                  }
                }}
              >
                {isConnected ? (
                  "Disconnect"
                ) : !platform?.providerType ? (
                  <FeatureComingSoon>Connect</FeatureComingSoon>
                ) : (
                  "Connect"
                )}
              </Button>
            </Col>
          </Row>
        );
      })}
      <EmailModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleConnect={(val) => handleConnect(val)}
      />
      <Modal
        title={
          <div
            className="heading24px text-color-1C1C1C roboto-medium"
            style={{ padding: "20px 24px 10px" }}
          >
            Disconnect Account
          </div>
        }
        className="delete-popup"
        open={isRemove}
        centered
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <div
          style={{ padding: "0 24px 20px 24px" }}
          className="web-to-lead mt10"
        >
          <div className="text-color-434040 heading16px mt10">
            <div>Are you sure you want to disconnect account?</div>
          </div>

          <div
            className="mt40 d-flex justify-content-end align-items-center"
            style={{ gap: 20 }}
          >
            <Button className="secondary-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              className="theme-btn"
              onClick={() => {
                handleDisconnect();
                handleCancel();
              }}
            >
              Disconnect
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Integrations;
